// TODO: generalize logic for screening quiz, testimonials

import {
  defaultGetSectionComponent,
  defaultGetQuestionComponent
} from 'dpl/quiz/utils';

import * as SECTION_COMPONENTS from '../sections/components';
import * as QUESTION_COMPONENTS from '../questions/components';

export function getSectionComponent(section) {
  return (
    SECTION_COMPONENTS[section.component_name] ||
    defaultGetSectionComponent(section)
  );
}

export function getQuestionComponent(question) {
  return (
    QUESTION_COMPONENTS[question.component_name] ||
    defaultGetQuestionComponent(question)
  );
}
